import React, { useState, useEffect } from 'react';
import {
  VscChevronRight,
  VscChevronDown,
  VscFolder,
  VscNewFolder,
  VscEdit,
  VscTrash,
} from 'react-icons/vsc';
import { UserAddOutlined, LoadingOutlined } from '@ant-design/icons';
import { Col, Form, Row, Select, Tag } from 'antd';
import colorsDark from '../../../assets/colors/dark';
import * as SERVICE from '../../../constants/service.types';
import { useDispatch, useSelector } from 'react-redux';
import { socketEmitEvent } from '../../../redux/actions';
import './index.scss';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import SingleSelect from '../../../../src/components/SingleSelect/SingleSelect';

const Folder = ({
  handleAddNewGroup,
  handleDeleteGroup,
  handleDeleteMember,
  handleUpdateNameGroup,
  explorerData,
  onHandleExpand,
  onUpdateGroup,
  onAddMemberGroup,
  // onCreateMembesGroup,
}) => {
  const dispatch = useDispatch();
  const {
    namespace: localNamespace,
    accountByNamespace,
    accountGroupMembers,
  } = useSelector((state) => state);
  const { t } = useTranslation();

  const [currentExplorer, setCurrentExplorer] = useState(explorerData || null);
  const [nodeName, setNodeName] = useState(
    explorerData?.name ? explorerData.name : ''
  );
  const [expand, setExpand] = useState(false);
  const [namespace, setNamespace] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [dataArr1, setDataArr1] = useState([]);
  const [dataArr, setDataArr] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [key, setKey] = useState(Math.random());
  const [form] = Form.useForm();
  const [isBlock, setIsBlock] = useState(false);
  const [requestId1, setRequestId] = useState();
  // const [loading, setLoading] = useState(false);

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
  };

  const memberRoleColors = (roleName) => {
    switch (roleName) {
      case 'admin':
        return colorsDark.$online;
      default:
        return colorsDark.$offline;
    }
  };

  const [showInput, setShowInput] = useState({
    visible: false,
    isFolder: null,
  });
  const [updateInput, setUpdateInput] = useState({
    visible: false,
    isFolder: null,
  });

  const [isAddMember, setIsAddMember] = useState(false);

  const handleNewGroupButton = (e, isFolder) => {
    e.stopPropagation();
    setExpand(true);
    setShowInput({
      visible: true,
      isFolder,
    });
  };
  const handleNewMemberButton = (e, isFolder) => {
    e.stopPropagation();
    setExpand(true);
    setShowInput({
      visible: true,
      isFolder,
    });
    setIsAddMember(!isAddMember);
  };

  const handleUpdateFolderButton = (e, nodeValue) => {
    setNodeName(nodeValue);
    e.stopPropagation();
    setUpdateInput({
      visible: true,
    });
    setIsEdit(true);
  };

  const handleDeleteFile = (e) => {
    e.stopPropagation();
    handleDeleteMember(currentExplorer);
  };

  const handleDeleteFolder = (e) => {
    e.stopPropagation();
    handleDeleteGroup(currentExplorer);
  };

  const handleInputChange = (e) => {
    setNodeName(e.target.value);
  };

  const onAdd = (e) => {
    if ((e.target.value && e.keyCode === 13) || e.type === 'click') {
      handleAddNewGroup(currentExplorer.id, nodeName, showInput.isFolder);
      setShowInput({ ...showInput, visible: false });
    }
  };

  const handleOnCancel = (e) => {
    e.stopPropagation();
    setShowInput({ ...showInput, visible: false });
  };

  const onUpdate = (e) => {
    if ((e.target.value && e.keyCode === 13) || e.type === 'click') {
      handleUpdateNameGroup(currentExplorer.id, nodeName, true);
      setUpdateInput({ ...updateInput, visible: false });
      setIsEdit(false);
    }
  };

  const onCancel = (e) => {
    e.stopPropagation();
    setUpdateInput({ ...updateInput, visible: false });
    setIsEdit(false);
  };
  const handleChange = (event) => {
    setNodeName(event.target.value);
  };

  const handleSelectedMember = (item) => {
    // setSelectedValues(values);
    // if (values && values.length > 0) {
    //   for (let i = 0; i < values.length; i++) {
    //     onChangeSearch(values[i]);
    //   }
    // }
    // onChangeSearch(item.accountId);
    onAddMemberGroup(currentExplorer, item);
  };

  const handleExpand = async () => {
    try {
      await onHandleExpand(currentExplorer.id);
    } catch (error) {
      console.error('Error in handleExpand:', error);
    } finally {
      setExpand((prevExpand) => !prevExpand);
      if (!expand) {
        setShowInput({ visible: false });
      }
    }
  };

  useEffect(() => {
    //update explorerDataList when listGroupByParentGroup change
    setCurrentExplorer(explorerData);
  }, [explorerData]);

  // const OnChange = (values) => {
  //   setSelectedValues(values);
  //   for (let i = 0; i < values.length; i++) {
  //     onChangeSearch(values[i]);
  //   }
  // };

  const onChangeSearch = (value) => {
    if (explorerData && explorerData.name) {
      let data = {
        namespace,
        groupId: explorerData.id,
        accountId: Number(value),
        indexOf: dataArr.length + 1,
      };
      let dataObj = {
        appServiceType: SERVICE.ADD_ACCOUNT_GROUP_MEMBER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }

    // Kiểm tra xem giá trị đã tồn tại trong dataArr hay chưa
    const exists = dataArr.some((item) => item.accountId === Number(value));

    if (exists) {
      // Xóa giá trị nếu đã tồn tại
      const updatedDataArr = dataArr.filter(
        (item) => item.accountId !== Number(value)
      );
      const updatedDataList = dataList.filter(
        (item) => item.accountId !== Number(value)
      );

      setDataArr(updatedDataArr);
      setDataList(updatedDataList);
    } else {
      // Thêm giá trị nếu chưa tồn tại
      const dataItem =
        dataArr1.find((x) => x.accountId === Number(value)) &&
        dataArr1.find((x) => x.accountId === Number(value));

      if (dataItem) {
        setDataArr([...dataArr, dataItem]);
        setDataList([...dataList, { accountId: Number(value) }]);
      }
    }

    // Cập nhật key để re-render nếu cần
    setKey(Math.random());
  };

  const onDelete = (value) => {
    if (explorerData && explorerData.name) {
      let data = {
        namespace,
        groupId: explorerData.id,
        accountId: Number(value.accountId),
      };
      let dataObj = {
        appServiceType: SERVICE.DELETE_ACCOUNT_GROUP_MEMBER,
        requestId: new Date().getTime(),
        body: JSON.stringify(data),
      };
      dispatch(socketEmitEvent(dataObj));
    }
    const data = [...dataList];
    const data1 = [...dataArr];
    const data2 = [...dataArr1];
    const sub = _.uniqBy(
      (data &&
        data.length > 0 &&
        data.filter((item) => item.accountId !== value.accountId)) ||
        [],
      'accountId'
    );
    setDataList(sub);
    const sub1 = _.uniqBy(
      (data1 &&
        data1.length > 0 &&
        data1.filter((item) => item.accountId !== value.accountId)) ||
        [],
      'accountId'
    );
    setDataArr(sub1);
    data2.unshift(value);
    setDataArr1(data2);
  };

  // const onFinish = (values) => {
  //   let current = new Date().getTime();

  //   setRequestId(current);
  //   onCreateMembesGroup(current, values, dataList);
  //   setShowInput({ ...showInput, visible: false });
  // };

  useEffect(() => {
    return () => {
      setIsBlock(false);
    };
  }, []);

  useEffect(() => {
    if (explorerData && explorerData.name && accountGroupMembers) {
      setDataList(
        accountGroupMembers.map((item) => ({
          accountId: item.accountId,
        }))
      );
      let data1 = [];
      accountGroupMembers.map((item1) => {
        data1 = [
          ...data1,
          ...(accountByNamespace.filter(
            (item2) => item1.accountId === item2.accountId
          ) || []),
        ];
      });
      setDataArr(data1);
      let sub = [...(accountByNamespace || [])];
      accountGroupMembers.map((item1) => {
        sub = _.uniqBy(
          (sub &&
            sub.length > 0 &&
            sub.filter((item2) => item1.accountId !== item2.accountId)) ||
            [],
          'accountId'
        );
      });
      setDataArr1(sub);
      form.setFieldsValue({
        name: explorerData.name,
      });
    } else {
      setDataArr1(accountByNamespace || []);
    }
  }, [accountByNamespace, accountGroupMembers, explorerData, form]);

  useEffect(() => {
    if (localNamespace) {
      setNamespace(localNamespace);
    }
  }, [localNamespace]);
  const { Option } = Select;

  const [selectedValues, setSelectedValues] = useState([]); // State lưu các giá trị đã chọn

  if (explorerData.isFolder) {
    return (
      <div className="table-parent">
        <div
          className="table-children"
          style={{ cursor: 'pointer' }}
          onClick={(event) => handleExpand(event)}
        >
          <span className="name">
            {expand ? <VscChevronDown /> : <VscChevronRight />}{' '}
            <VscFolder color="#0e9347" />
            {updateInput.visible ? (
              <input
                type="text"
                value={nodeName}
                onChange={handleChange}
                autoFocus
                onBlur={() =>
                  setUpdateInput({ ...updateInput, visible: false })
                }
                onKeyDown={onUpdate}
              />
            ) : (
              <label>{explorerData.name || explorerData.fullName}</label>
            )}
          </span>

          <div className="buttons-container">
            {!isEdit && (
              <div className="button-action">
                {explorerData.isLoading === true && <LoadingOutlined />}
                <button onClick={(e) => handleDeleteFolder(e, true)}>
                  <VscTrash color="red" />
                </button>
                <button
                  onClick={(e) =>
                    handleUpdateFolderButton(e, explorerData.name)
                  }
                >
                  <VscEdit />
                </button>

                <button onClick={(e) => handleNewGroupButton(e, true)}>
                  <VscNewFolder color="#0e9347" />
                </button>
                <button onClick={(e) => handleNewMemberButton(e, false)}>
                  {/* <GoDeviceCameraVideo /> */}
                  <UserAddOutlined style={{ color: '#0e9347' }} />
                </button>
              </div>
            )}
            {isEdit && (
              <div className="editMode">
                <span onClick={onUpdate} style={{ color: '#0e9347' }}>
                  Update
                </span>
                <span onClick={onCancel} style={{ color: '#4f4d4d' }}>
                  Cancel
                </span>
              </div>
            )}
          </div>
        </div>
        <div
          id="folderContainer"
          style={{ display: expand ? 'block' : 'none', paddingLeft: 20 }}
        >
          {showInput.visible && (
            <div className="addItem" style={{ width: '100%' }}>
              <span className="name" style={{ width: '100%' }}>
                {showInput.isFolder ? (
                  <div className="createMode">
                    <div>
                      <VscFolder color="#0e9347" />
                      <input
                        type="text"
                        autoFocus
                        // onBlur={() =>
                        //   setShowInput({ ...showInput, visible: false })
                        // }
                        onKeyDown={onAdd}
                        onChange={handleInputChange}
                        placeholder="Add new group..."
                        style={{ marginLeft: '4px' }}
                      />
                    </div>
                    <div>
                      <button
                        onClick={onAdd}
                        style={{
                          marginRight: '8px',
                          backgroundColor: '#000',
                          color: '#0e9347',
                        }}
                      >
                        Create
                      </button>
                      <button
                        style={{ backgroundColor: '#000', color: '#4f4d4d' }}
                        onClick={handleOnCancel}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  // <VscFile />
                  <>
                    <div
                      className="create-marker-component"
                      style={{ width: '100%' }}
                    >
                      <SingleSelect
                        dataArr1={dataArr1}
                        handleSelect={handleSelectedMember}
                      />
                    </div>
                  </>
                )}
              </span>
            </div>
          )}
          {explorerData.items?.map((item, index) => {
            return (
              <Folder
                handleDeleteGroup={handleDeleteGroup}
                handleDeleteMember={handleDeleteMember}
                handleAddNewGroup={handleAddNewGroup}
                handleUpdateNameGroup={handleUpdateNameGroup}
                explorerData={item}
                key={index}
                onHandleExpand={onHandleExpand}
                onUpdateGroup={onUpdateGroup}
                onAddMemberGroup={onAddMemberGroup}
                // onCreateMembesGroup={onCreateMembesGroup}
              />
            );
          })}
        </div>
      </div>
    );
  } else {
    return (
      <div className="table-children">
        <span className="name">
          <UserAddOutlined style={{ color: '#0e9347' }} />
          {updateInput.visible ? (
            <input
              type="text"
              value={nodeName}
              onChange={handleChange}
              autoFocus
              onBlur={() => setUpdateInput({ ...updateInput, visible: false })}
              onKeyDown={onUpdate}
            />
          ) : (
            <label>{explorerData.name || explorerData.fullName}</label>
          )}
        </span>
        <div className="buttons-container">
          <button onClick={(e) => handleDeleteFile(e, false)}>
            <VscTrash color="red" />
          </button>
          {/* <button
            onClick={(e) =>
              handleUpdateFolderButton(e, false, explorerData.name)
            }
          >
            <VscEdit />
          </button> */}
        </div>
      </div>
    );
  }
};

export default Folder;
